import { createFileRoute } from '@tanstack/react-router'
import { CreateProcedurePage } from '_/features/pets/ui/pages/create-procedure-page'

const CreateProcedureRoute = () => {
	const { petId } = Route.useParams()
	return <CreateProcedurePage petId={petId} />
}

export const Route = createFileRoute('/_authenticated/pets/$petId/procedures/create')({
	staticData: { title: 'procedures_create_title' },
	component: CreateProcedureRoute,
})
